export enum BillingStatus {
  Trial = 1,
  Active = 2,
  Cancelled = 3,
  FreeForever = 4,
  OpenCollective = 5,
}
